import { ReactNode, useEffect, useState } from "react";
import { useLocation, useOutlet } from "react-router";
import useFooterTabs from "../../../hooks/useHeaderTabs";

type CachedOutlet = {
	key: string;
	component: ReactNode;
};

function PersistentOutlet() {
	const outlet = useOutlet();
	const location = useLocation();
	const [cache, setCache] = useState<Record<string, ReactNode>>({});
	const { tabs } = useFooterTabs();

	useEffect(() => {
		if (!outlet) return;

		setCache((prev) => {
			if (prev[location.pathname]) return prev;

			return {
				...prev,
				[location.pathname]: outlet,
			};
		});
	}, [location.pathname, outlet]);

	// Remove do cache as rotas que não possuem mais abas associadas
	useEffect(() => {
		setCache((prev) => {
			const allowed = new Set<string>([location.pathname, ...tabs.map((tab) => tab.url)]);
			const next: Record<string, ReactNode> = {};

			Object.entries(prev).forEach(([key, component]) => {
				if (allowed.has(key)) next[key] = component;
			});

			return next;
		});
	}, [tabs, location.pathname]);

	const entries: CachedOutlet[] = Object.entries(cache).map(([key, component]) => ({
		key,
		component,
	}));

	if (!entries.length && outlet) return <>{outlet}</>;

	return (
		<>
			{entries.map(({ key, component }) => (
				<div
					key={key}
					style={{
						display: key === location.pathname ? "block" : "none",
						height: "100%",
					}}
				>
					{component}
				</div>
			))}
		</>
	);
}

export default PersistentOutlet;
